import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const CollapsibleSection = ({ title, badge, actions, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Box className={`zf-section-box ${isOpen ? 'is-open' : 'is-collapsed'}`}>
      <div className="zf-section-box__header" onClick={() => setIsOpen(!isOpen)}>
        <div className="zf-section-box__title-row">
          <h3>{title}</h3>
          {badge && <span className="zf-mini-badge">{badge}</span>}
          {actions && <div onClick={(e) => e.stopPropagation()}>{actions}</div>}
        </div>
        <button
          className="zf-section-box__toggle" 
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          {isOpen ? '−' : '+'}
        </button>
      </div>
      <div className="zf-section-box__body">
        {children}
      </div>
    </Box>
  );
};

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
};

export default CollapsibleSection;
